/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Directory_Ai_Tools_Studio_GenerateInputs */

const en_directory_ai_tools_studio_generate = /** @type {(inputs: Directory_Ai_Tools_Studio_GenerateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generate our rap video · ${i?.credits} credits`)
};

const zh_directory_ai_tools_studio_generate = /** @type {(inputs: Directory_Ai_Tools_Studio_GenerateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`生成我们的说唱视频 · ${i?.credits} 积分`)
};

/**
* | output |
* | --- |
* | "Generate our rap video · {credits} credits" |
*
* @param {Directory_Ai_Tools_Studio_GenerateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_generate = /** @type {((inputs: Directory_Ai_Tools_Studio_GenerateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_GenerateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_generate(inputs)
	return zh_directory_ai_tools_studio_generate(inputs)
});
export { directory_ai_tools_studio_generate as "directory.ai_tools.studio.generate" }